export default __webpack_public_path__ + "static/media/kitchen3-before2-480w.55eaf1e0.webp";